const BodyGroup = ({ data }) => {
  return (
    <>
      <div className="cf-body--grid">
        {data.map((content) => (
          <div
            key={content.id}
            className={`wp-block-group cf--side-by-side is-layout-flow wp-block-group-is-layout-flow cf-${content.class}`}
          >
            <div className="wp-block-group__inner-container">
              <section className="cf-content-box">
                <h2 className="wp-block-heading">{content.heading}</h2>
                <p>{content.paragraph}</p>
                <p>
                  <a
                    className="cf--color-heading-cta"
                    href={content.link}
                    data-type="page"
                  >
                    {content.linkText}
                  </a>
                </p>
              </section>
              <div className="wp-block-group__inner-container wp-block-image size-large">
                <img className="cf-block-img" src={content.image} alt={content.heading} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BodyGroup;
